import { EditorState, RichUtils } from "draft-js";
import { BoldIcon, CodeIcon, ItalicIcon, ListIcon, ListOrderedIcon } from "lucide-react";

export default function Toolbar({ editorState, setEditorState }: { editorState: EditorState; setEditorState: (state: EditorState) => void }) {
    const tools = [
        {
            label: "bold",
            style: "BOLD",
            icon: <BoldIcon className="w-5" />,
            method: "inline",
        },
        {
            label: "italic",
            style: "ITALIC",
            icon: <ItalicIcon className="w-5" />,
            method: "inline",
        },
        {
            label: "Unordered-List",
            style: "unordered-list-item",
            method: "block",
            icon: <ListIcon className="w-5" />,
        },
        {
            label: "Ordered-List",
            style: "ordered-list-item",
            method: "block",
            icon: <ListOrderedIcon className="w-5" />
        },
        {
            label: "Monospace",
            style: "CODE",
            icon: <CodeIcon className="w-5" />,
            method: "inline",
        },
    ];

    const applyStyle = (e: React.MouseEvent, style: string, method: string): void => {
        e.preventDefault();
        if (method === "block") {
            setEditorState(RichUtils.toggleBlockType(editorState, style));
        } else {
            setEditorState(RichUtils.toggleInlineStyle(editorState, style));
        }
    };

    const isActive = (style: string, method: string) => {
        if (method === "block") {
            const selection = editorState.getSelection();
            const blockType = editorState
                .getCurrentContent()
                .getBlockForKey(selection.getStartKey())
                .getType();
            return blockType === style;
        } else {
            const currentStyle = editorState.getCurrentInlineStyle();
            return currentStyle.has(style);
        }
    };

    return (
        <div className="flex flex-row space-x-2 items-center border-b border-gray-300 px-3 py-2">
            {tools.map((item, idx) => (
                <div className="w-6 h-6" key={`${item.label}-${idx}`}>
                    <button
                        style={{
                            color: isActive(item.style, item.method)
                                ? "rgba(0, 0, 0, 1)"
                                : "rgba(0, 0, 0, 0.3)",
                        }}
                        title={item.label}
                        onClick={(e) => applyStyle(e, item.style, item.method)}
                        onMouseDown={(e) => e.preventDefault()}
                    >
                        {item.icon || item.label}
                    </button>
                </div>
            ))}
        </div>
    );
};